import { request } from "@/services/network";

export async function getSubscriptionDetails() {
	return request({
		url: "/payments/subscription-details/",
		method: "GET",
	});
}

export async function getPriceInfo() {
	return request({
		url: "/payments/price-info/",
		method: "GET",
	});
}

export async function createSubscriptionOrder(payment_plan) {
	return request({
		url: "/payments/create-subscription-order/",
		method: "POST",
		data: { payment_plan },
	});
}

export async function enableAutoRenew() {
	return request({
		url: "/payments/auto-renew/enable/",
		method: "POST",
	});
}

export async function disableAutoRenew() {
	return request({
		url: "/payments/auto-renew/disable/",
		method: "POST",
	});
}

export async function changePlan(payment_plan) {
	return request({
		url: "/payments/plan/change/",
		method: "POST",
		data: { payment_plan },
	});
}

export async function createPaymentMethodSession() {
	return request({
		url: "/payments/payment-method/update-session/",
		method: "POST",
	});
}
